// Confirmation copy shared between the shift definitions UI and (eventually)
// anywhere else a deactivation is triggered. Kept in one place because the
// message understates the real blast radius today: deactivating a shift
// drops every employee whose only *live* assignment rule pointed at it down
// to the next tier of the precedence ladder, or to Unassigned — with no
// count shown yet. Task 16 adds that count; when it does, this is the only
// function that needs to change.
export function deactivateShiftConfirm(shift, affectedCount) {
    const base = `Deactivate "${shift.name}"? Existing attendance keeps referencing it.`;
    if (typeof affectedCount === "number") {
        return `${base} ${affectedCount} employee(s) will fall through to the next matching rule, or to Unassigned.`;
    }
    // affectedCount is undefined when the real count could not be obtained --
    // a scoped fetch failed, or the caller can't see every company a shared
    // shift reaches. Deliberately never shown as "0" and never silently
    // dropped: either would read as a confident number this wasn't.
    return `${base} The affected count could not be loaded. Any employee whose only `
        + "live rule points here falls through to the next matching rule, or to Unassigned.";
}
